enum Types {
  GET_ERRORS_REQUEST = 'GET_ERRORS_REQUEST',
  GET_ERRORS_FULFILLED = 'GET_ERRORS_FULFILLED',
  GET_ERRORS_REJECTED = 'GET_ERRORS_REJECTED',

  CLEAR_FIELDS_REQUEST = ' CLEAR_FIELDS_REQUEST',
  CLEAR_FIELDS_FULFILLED = ' CLEAR_FIELDS_FULFILLED',
}

export default Types;
